import React from "react";
import { WfControlProps } from "./ControlProps";
import HeadingComponent from "../../../../../../components/ControlComponents/MainTextComponents/HeadingComponent/HeadingComponent";

export function WfHeading({ layout }: Readonly<WfControlProps>) {
  return (
    <HeadingComponent
      template={layout.template}
      data={layout.data}
      rowIdx={0}
      colIdx={0}
    />
  );
}
